import ApiBase from "./ApiBase";

export default class Newsletter {
    /*InxMail*/
    static getAllNewsletters(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.getData("/api/newsletter/getallnewsletters", query, successCallback, errorCallback, alwaysCallback);
    }
    static getHsluNewsletter(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.getData("/api/newsletter/gethslunewsletter", query, successCallback, errorCallback, alwaysCallback);
    }
    static getConfigurations(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.postData("/api/newsletter/getconfigurations", query, successCallback, errorCallback, alwaysCallback);
    }
    static saveConfigurations(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.postData("/api/newsletter/saveconfigurations", query, successCallback, errorCallback, alwaysCallback);
    }
    static registerToLists(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.postData("/api/newsletter/registertolists", query, successCallback, errorCallback, alwaysCallback);
    }
   /*Mailchimp*/
    static getListGroupings(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.getData("/api/newsletter/getlistgroupings", query, successCallback, errorCallback, alwaysCallback);
    }
    static getMember(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.getData("/api/newsletter/getmember", query, successCallback, errorCallback, alwaysCallback);
    }
    static subscribe(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.postData("/api/newsletter/subscribe", query, successCallback, errorCallback, alwaysCallback);
    }
    static unsubscribe(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.postData("/api/newsletter/unsubscribe", query, successCallback, errorCallback, alwaysCallback);
    }
    static resendVerificationEmail(query, successCallback, errorCallback, alwaysCallback) {
        return ApiBase.postData("/api/newsletter/resendverificationemail", query, successCallback, errorCallback, alwaysCallback);
    }
}
